var _symbol, _use, _view;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "sprite-brackes-icon-bw",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.129 19.087a.568.568 0 110-1.137.568.568 0 010 1.137zm-6.254-6.253a.568.568 0 110-1.137.568.568 0 010 1.137zm1.832 4.421a.568.568 0 110-1.137.568.568 0 010 1.137zm0-8.88a.568.568 0 110-1.137.568.568 0 010 1.136zm8.843 8.88a.568.568 0 110-1.137.568.568 0 010 1.137zm-3.853-15.26c5.334 0 9.702 4.368 9.702 9.702a.569.569 0 01-.569.568h-.606c0 5.037-4.08 9.134-9.095 9.134-5.028 0-9.134-4.106-9.134-9.134 0-5.027 4.106-9.133 9.134-9.133v-.568c0-.314.254-.569.568-.569zm-.568 18.267c4.388 0 7.958-3.591 7.958-8h-1.705a.565.565 0 01-.569-.565c0-2.842-2.295-5.154-5.116-5.154a.568.568 0 01-.568-.569V4.27c-4.41 0-7.997 3.587-7.997 7.996 0 4.41 3.587 7.997 7.997 7.997zm6.796-9.133h2.318c-.281-4.271-3.707-7.697-7.978-7.978v2.28c3 .274 5.392 2.702 5.66 5.698zm-6.796-3.45c2.507 0 4.547 2.058 4.547 4.586a4.553 4.553 0 01-4.547 4.548 4.553 4.553 0 01-4.548-4.548c0-2.528 2.04-4.585 4.548-4.585zm0 7.997c1.88 0 3.41-1.53 3.41-3.41 0-1.902-1.53-3.45-3.41-3.45-1.881 0-3.411 1.548-3.411 3.45 0 1.88 1.53 3.41 3.41 3.41zm0-5.684a2.276 2.276 0 012.273 2.273 2.276 2.276 0 01-2.273 2.274 2.276 2.276 0 01-2.274-2.274 2.276 2.276 0 012.274-2.273zm0 3.41a1.138 1.138 0 10-1.137-1.137c0 .627.51 1.137 1.136 1.137z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sprite-brackes-icon-bw"
  })), _view || (_view = /*#__PURE__*/React.createElement("view", {
    id: "sprite-brackes-icon-bw"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscIcon);
export default __webpack_public_path__ + "static/media/discIcon.124e552c5cce5b878949aa10840a63c9.svg";
export { ForwardRef as ReactComponent };